module.exports = __webpack_public_path__ + "media/packs/images/flags/VE-4e22126d5fec2f48b0fb0aadf38fc830.svg";